module.exports = __webpack_public_path__ + "img/img_2.5077cfda.png";